module.exports = __webpack_public_path__ + "media/application/images/svgs/swoosh-2edcbe437431197ec0b8cfa5f870f504.svg";